import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL, companyId, MenuCategoriesEndPoint } from "../../Api/api";

export const menuCategoriesApi = createApi({
  reducerPath: "menuCategoriesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
  }),
  tagTypes: ["MenuCategory"],

  endpoints: (builder) => ({
    // Get all menu categories with pagination
    getAllMenuCategories: builder.query({
      query: ({ limit = 100, page = 1 }) => {
        const url = `${MenuCategoriesEndPoint}?companyId=${companyId}&limit=${limit}&page=${page}`;

        // 🧭 Log outgoing request
        console.log("📤 Fetching Menu Categories:", {
          companyId,
          limit,
          page,
          url,
        });

        return url;
      },
      transformResponse: (response) => {
        // ✅ Log successful response
        console.log("✅ Menu Categories fetched successfully:", response);
        return response;
      },
      onError: (error) => {
        // ❌ Log error (for debugging)
        console.error("❌ Failed to fetch Menu Categories:", error);
      },
      providesTags: ["MenuCategory"],
    }),

    // Get one menu category by ID
    getOneMenuCategory: builder.query({
      query: (id) => `${MenuCategoriesEndPoint}/${id}?companyId=${companyId}`,
      providesTags: ["MenuCategory"],
    }),
  }),
});

// Export hooks for using these endpoints in components
export const { useGetAllMenuCategoriesQuery, useGetOneMenuCategoryQuery } =
  menuCategoriesApi;
